import { FormStore } from '@estee/elc-form';
import { ILogin } from './Login';
import { RampFormValidator } from '../../controllers/common/RampFormValidator';

export class LoginFormStore extends FormStore<ILogin> {
    constructor() {
        super({
            initialValues: {
                email: '',
                password: '',
                mobileNumber: '',
                countryCode: ''
            },
            formValidator: new RampFormValidator()
        });
    }
}
